(function () {
  'use strict';
  angular.module('vcfinance.privcat')
    .component('privcatgroupeditor', {
      restrict: 'E',
      bindings: {
        privcatgroup: '<?',
        pricatgroupid: '<?'
      },
      template: `
        <privcatgroupform privcatgroup="vm.privcatgroup" parentsave="vm.childsave(privcatgroup)" oncancel="vm.oncancel()"></privcatgroupform>
        <div ng-show="vm.saved === true" class="alert alert-success spacer-top spacer-bottom">
          <h3><i class="fa fa-check"></i> Leistungsgruppe erfolgreich gespeichert!</h3>
        </div>
        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">
          <h3><i class="fa fa-info"></i> Das Editieren einer Leistungsgruppe wurde abgebrochen!</h3>
        </div>
        <div ng-show="vm.saved === false" class="alert alert-danger spacer-top spacer-bottom">
          <h3>
            <i class="fa fa-warning"></i> Leistungsgruppe konnte nicht gespeichert werden,
            der Fehler wurde protokolliert!
            </h3>
        </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Privcat', 'Rlog',
        function ($log, Privcat, Rlog) {
          let vm = this;
          vm.save = save;
          vm.childsave = childsave;
          vm.oncancel = oncancel;

/*
          vm.$onInit = function () {
            if ((angular.isUndefined(vm.privcatgroup) || !vm.privcatgroup.hasOwnProperty('_id'))
              && angular.isDefined(vm.pricatgroupid)) {
              Privcat.$find(vm.pricatgroupid).$then(function (privcatgroup) {
                vm.privcatgroup = privcatgroup;
              }, function (err) {
                $log.error('privcatgroup not found, id: ', vm.pricatgroupid);
                Rlog.error('privcatgroup', 'privcateditor', 'privcatgroup not found', {_id: vm.pricatgroupid});
              });
            }
          };
*/

          vm.$onChanges = function (changes) {
            if (angular.isDefined(changes.pricatgroupid) && angular.isDefined(changes.pricatgroupid.currentValue) && changes.pricatgroupid.currentValue.length > 0) {
              vm.pricatgroupid = changes.pricatgroupid.currentValue;
              Privcat.$find(vm.pricatgroupid).$then(function (privcatgroup) {
                vm.privcatgroup = privcatgroup;
              }, function (err) {
                $log.error('privcatgroup not found, id: ', vm.pricatgroupid);
                Rlog.error('privcatgroup', 'privcateditor', 'privcatgroup not found', {_id: vm.pricatgroupid});
              });
            }
          };

          function childsave(privcatgroup) {
            // vm.privcatgroup = angular.copy(privcatgroup);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (let key in privcatgroup) {
              if (privcatgroup.hasOwnProperty(key)) {
                vm.privcatgroup[key] = privcatgroup[key];
              }
            }
            vm.save();
          }

          function save() {
            delete vm.canceled;
            delete vm.saved;
            delete vm.error;
            if (vm.privcatgroup.$hasPendingActions()) {
              vm.privcatgroup.$cancel();
              vm.privcatgroup.$save().$then(function () {
                vm.saved = true;
              }, function (err) {
                vm.saved = false;
                $log.error('saving of privcatgroup failed: ', err);
                Rlog.error('vcutils.privcatgroup', 'privcatgroupeditor', 'Saving of privcatgroup failed: ', {
                  error: err,
                  privcatgroupid: vm.privcatgroup._id
                });
              });
            } else {
              vm.privcatgroup.$save().$then(function () {
                vm.saved = true;
              }, function (err) {
                vm.saved = false;
                $log.error('saving of privcatgroup failed: ', err);
                Rlog.error('vcutils.privcatgroup', 'privcatgroupeditor', 'Saving of privcatgroup failed: ', {
                  error: err,
                  privcatgroupid: vm.privcatgroup._id
                });
              });
            }
          }

          function oncancel() {
            delete vm.saved;
            delete vm.error;
            vm.canceled = true;
          }


        }] // controller
    }); // component

// klammerfriedhof
}());